
import imgPlaceholder from "../../assets/img/default-img-placeholder.png";
import HrButton from "../Customer/UIElement/HrButton";


type DocumentItem = {
  id: number;
  title: string;
  fileName?: string;
  hasFile: boolean;
};

type DocumentCardProps = {
  item: DocumentItem;
  onUpload: (id: number) => void;
};

export default function DocumentCard({ item, onUpload }: DocumentCardProps) {
  return (
    <div
      className="p-5 border w-[246px] relative hover:shadow-lg 
      border-gray-200 hover:border-gray-300  
      transition-all duration-200 hover:-translate-y-1 
      rounded-xl bg-white"
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-2xl">
          <img src={imgPlaceholder} alt="pdf" />
        </div>

        <div>
          <p className="text-sm font-semibold text-gray-800">
            {item.title}
          </p>

          <p className="text-xs text-gray-500">
            {item.hasFile ? item.fileName : "No file uploaded"}
          </p>
        </div>
      </div>

      <HrButton
        label={item.hasFile ? "Replace" : "Upload"}
        onClick={() => onUpload(item.id)}
        className={"!px-2 !py-[1px] !gap-1"}
      />
    </div>
  );
}